exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stepper__tabs{display:flex;padding:0;margin:0;list-style:none}.stepper__tab{padding:0 10px;cursor:pointer}.stepper__tab--active{font-weight:600}.stepper__tab--disabled{color:#666}.stepper__tab--active,.stepper__tab--disabled{cursor:text}", ""]);

// exports
